import styles from './logoCarousel.module.scss'

const LogoCarousel = ({ logos, tagline }) => {
  return (
    <div>
      {tagline && (
        <p className={styles.tagline} align="center">
          {tagline}
        </p>
      )}
      <div className={styles.logoContainer}>
        <div className={styles.logos}>
          <div className={styles.logosSlide}>
            {logos.map((logo, index) => (
              <img key={index} src={logo.img} alt={logo.name} />
            ))}
          </div>
          <div className={styles.logosSlide}>
            {logos.map((logo, index) => (
              <img key={index} src={logo.img} alt={logo.name} />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default LogoCarousel
